<template>
  <div class="page">
  </div>
</template>

<script>
export default {
  name: 'logout',
  created: function () {
    this.logout()
  },
  methods: {
    logout: function () {
      this.$store.dispatch('logout')
    }
  }
}
</script>

<style scoped>
.page {
  /* size */
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Logout.vue